import React from 'react';
import { WireTransferGroup } from '../../../models/FlowOfFunds/flow-of-funds.model';
import { ConfirmToggleButton } from './ConfirmToggleButton';
import { ConfirmationMeta } from './ConfirmationMeta';

export interface ReceiptConfirmationControlProps {
    group: WireTransferGroup;
    isPending: boolean;
    onConfirm: () => void;
    onUndo: () => void;
}

export const ReceiptConfirmationControl = ({
    group,
    isPending,
    onConfirm,
    onUndo,
}: ReceiptConfirmationControlProps) => {
    if (!group.canConfirmReceipt) {
        return <ConfirmationMeta confirmation={group.receiptConfirmation} />;
    }

    if (group.receiptConfirmation) {
        return (
            <>
                <ConfirmToggleButton
                    label="Confirm Received"
                    pendingLabel="Undoing…"
                    isOn
                    isPending={isPending}
                    onClick={onUndo}
                />
                <ConfirmationMeta confirmation={group.receiptConfirmation} />
            </>
        );
    }

    return (
        <ConfirmToggleButton
            label="Confirm Received"
            pendingLabel="Confirming…"
            isOn={false}
            isPending={isPending}
            disabled={!group.sentConfirmation}
            onClick={onConfirm}
        />
    );
};
